const CustomLoader = () => {
    return (
        <div>loading</div>
    );
};

export default CustomLoader;